import * as React from "react"
import { Link } from "gatsby"
import Button from './Button'
import Newsletter from './Newsletter'
import AdSense from 'react-adsense';
import { navigateToSearch } from '../scripts/search'

import Cover from '../images/cover.png'
import QUIZ from '../images/quiz-callout.jpg'

const MAX_RECENT_POSTS = 5;

const Sidebar = ({posts}) => {
 const [searchQuery, setSearchQuery] = React.useState("");

 const formattedPosts = posts.slice(0, MAX_RECENT_POSTS);

 return (
   <div>
    <div className="py-8 flex flex-wrap">
      <input style={{width: "175px"}} className="py-1 pl-1 pr-4 rounded-md" type="text" placeholder="Search" onChange={(event) => setSearchQuery(event.target.value)}/>
      <Button type="primary" text="Go" isSmall={true} onClick={() => navigateToSearch(searchQuery)}/>
    </div>
    <div className="py-8 italic">
      <p>As an Amazon Associate we earn from qualifying purchases. Links on this site may direct you to Amazon where we earn a small commission from each sale. This helps support the site and our mission.</p>
    </div>
    <div className="py-8">
      <AdSense.Google
        client='ca-pub-7918336603285970'
        slot='4634402473'
      />
    </div>
    <div className="py-8">
      <a href="http://quiz.theindoorgardens.com" target="_blank">
        <img src={QUIZ} alt="Which plant to grow quiz callout" width="100%" />
      </a>
    </div>
    <div className="py-8">
      <h3 className="text-xl">Subscribe To Our Mailing List</h3>
      <Newsletter />
    </div>
    <div className="py-8">
      <h3 className="text-xl">Buy Our E-Book!</h3>
      <a href="https://www.amazon.com/dp/B0721QSSGK/ref=as_li_ss_il?ie=UTF8&linkCode=li2&tag=totalwebcon0b_indoorgardens-20&linkId=fc09155ce1707abed45d5cdb888d142a" rel="noreferrer" target="_blank">
        <img src={Cover} alt="Indoor Gardens E-Book" width="210px" height="208px"/>
      </a>
    </div>
    <div className="py-8">
      <h3 className="text-xl pb-4">Recent Posts</h3>
      {
        formattedPosts.map(post => {
          return (
            <div className="py-2" key={post.frontmatter.id}>
              <Link to={ post.fields.slug } itemProp="url" className="hover:text-primary transition border-b-2 border-primary pb-1">
                <h4 className="text-base">{post.frontmatter.title}</h4>
              </Link>
            </div>
          )
        })
      }
    </div>
   </div>
 )
}


export default Sidebar
